import React from 'react';
import HelpContent from './HelpContent';
import Electrificacion_Coccion_Hogar from 'img/Electrificacion_Coccion_Hogar.png';

const ElectrificacionCoccionMineriaHelp = () => (
  <HelpContent>
   <h1>Electrificación de cocción en hogares</h1>
    <p>
    Esta medida evalúa el impacto de la introducción de cocinas eléctricas que reemplacen el uso de cocinas convencionales que utilizan gas natural 
    o gas licuado. La siguiente figura muestra algunos ejemplos de cocina eléctrica vitrocerámica y una de platos eléctricos.
    </p>
	  <img src={Electrificacion_Coccion_Hogar} alt="Ejemplo de artefactos eléctricos para cocción"/>
    <label>Figura: Electrificación de coccón </label>
    <p>
    <strong>Trayectoria 1:</strong> al año 2030 un 8% de los hogares poseen sistemas de cocción eléctricos y 59% al 2050.
    </p>

  </HelpContent>
);

export default ElectrificacionCoccionMineriaHelp;
